var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcFileSpreadsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0C10.7452 0 0 10.7452 0 24V176C0 189.255 10.7452 200 24 200H176C189.255 200 200 189.255 200 176V24C200 10.7452 189.255 0 176 0H24ZM127.26 138.933C128.507 138.493 129.973 137.54 131.66 136.073C134.153 133.946 135.363 132.04 135.29 130.353C135.29 128.666 134.263 126.686 132.21 124.413L111.043 99.6954L132.21 75.0229C134.263 72.8229 135.29 70.8428 135.29 69.0829C135.363 67.3229 134.153 65.3795 131.66 63.2529C130.047 61.7129 128.617 60.7228 127.37 60.2828C126.123 59.8428 124.913 59.9162 123.74 60.5029C122.567 61.0895 121.283 62.2262 119.89 63.9128L100.145 86.9697L80.4 63.9128C79.0067 62.2262 77.7233 61.0895 76.55 60.5029C75.3767 59.9162 74.1667 59.8428 72.92 60.2828C71.6733 60.7228 70.2433 61.7129 68.63 63.2529C66.21 65.3795 65 67.3229 65 69.0829C65 70.8428 66.0267 72.8229 68.08 75.0229L89.2471 99.6954L68.08 124.413C66.0267 126.686 65 128.666 65 130.353C65 132.04 66.21 133.946 68.63 136.073C70.3167 137.54 71.7833 138.493 73.03 138.933C74.2767 139.373 75.4867 139.3 76.66 138.713C77.8333 138.126 79.08 137.026 80.4 135.413L100.145 112.398L119.89 135.413C121.283 137.026 122.53 138.126 123.63 138.713C124.803 139.3 126.013 139.373 127.26 138.933Z",
    fill: "#01AC49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcFileSpreadsheet);
export default __webpack_public_path__ + "static/media/mc-file-spreadsheet.689c5616a1bd6e64d6fae7d0caa72cc1.svg";
export { ForwardRef as ReactComponent };